import { TabBookingAbstract } from './tabBookingAbstract'
import { ContainerManager } from './containerManager'
import StrUtils from '@/utils/StrUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { TabError } from '@/utils/class/TabError'
import { sortByMultiField } from '@/utils'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { syncLclSlaveMasterJob } from '@/api/booking/job'
import { batchAddJob } from '@/api/SeaImport/seaImportJob'
import { batchRemoveJob, checkJobForShared } from '@/api/seaExport/seaExportJob'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export class TabLclContainerBase extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.$message = this.view.$message
    this.$confirm = this.view.$confirm
    this.$refs = this.view.$refs
    this.$store = this.view.$store
    this.$i18n = this.view.$i18n
    this.$emit = this.view.$emit
    this.$t = this.view.$t
    this.$checkPermission = this.view.$checkPermission

    this.manager = null
  }

  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  //  装箱明细
  get containerUsageColl() {
    return this.view.containerUsageColl
  }
  set containerUsageColl(containerUsageColl) {
    this.view.containerUsageColl = containerUsageColl
  }

  async commitProperties() {
    this.refreshContainers()

    //   lclSalve 关联containers的同一usages
    await this.refreshSlaveUsageColl()

    this.refreshDatas()
  }

  // lclSalve 关联containers的同一usages
  refreshSlaveUsageColl() {
    for (const slave of this.job.lclSlaves) {
      slave.containerUsages = []
    }
    for (const container of this.job.containers) {
      for (const usage of container.containerUsage) {
        const slave = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
        if (!slave) {
          continue
        }
        slave.containerUsages.push(usage)
      }
    }
  }
  /**
   * 刷新箱子
   */
  refreshContainers() {
    const job = this.job
    if (!this.manager || !job) { return }

    if (job.containers && job.containers.length > 0) {
      // 默认选中第一行
      this.view.$nextTick(async() => {
        await this.setGridSelect()
        this.containerChangeHandler()
      })
    } else {
      this.refreshUsages()

      // 没有箱子的情况下，重置装箱信息，避免装箱grid 数据未重置
      const container = this.view.selectedContainer
      if (container) {
        container.containerUsage = []
      }
    }
  }
  // 箱子设置 选中行(加载数据后默认选中第一行记录)
  setGridSelect() {
    const nodes = this.view.left.gridOptions.api.getRenderedNodes()
    if (!nodes) {
      return
    }
    // 默认选中第一个
    for (const item of nodes) {
      item.setSelected(true)
      this.view.selectedContainer = item.data
      break
    }
  }

  // 装箱信息 设置 选中行
  setUsageGridSelect(selectedRows) {
    const gridApi = this.view.right.gridApi
    const nodes = gridApi.getRenderedNodes()

    for (const item of nodes) {
      if (selectedRows.findIndex(p => p.jobUuid === item.data.jobUuid) > -1) {
        item.setSelected(true)
      }
    }
  }

  // 箱子grid 选中事件
  containerChangeHandler(event = null) {
    if (event) {
      this.view.selectedContainer = event.data
    }
    this.refreshUsages()
  }

  /**
   * 刷新用量
   */
  refreshUsages() {
    if (!this.manager) { return }
    const container = this.view.selectedContainer
    if (container) {
      this.refreshContainerUsageColl(container)
      if (this.containerUsageColl) {
        let index = 0
        // todo serialNo 与cargo 写法不同 从最初开始编码
        index = 1
        for (const c of this.containerUsageColl) {
          c.serialNo = index++
        }
        this.view.right.gridOptions.api.refreshCells({ force: true })
      }
      // 排序
      sortByMultiField(this.containerUsageColl, ['serialNo'], false)
      // 改为 push 避免同一引用 多个container引用指向同一个
      container.containerUsage = []
      for (const usage of this.containerUsageColl) {
        container.containerUsage.push(usage)
      }

      this.view.usagesTotalDesc.txtNum = this.view.$t('Message.Count') + '：' + (this.containerUsageColl == null ? 0 : this.containerUsageColl.length)
    } else {
      this.containerUsageColl = []
      this.view.usagesTotalDesc.txtNum = this.view.$t('Message.Count') + '：0'
    }

    let quantity = 0
    let weight = 0
    let cubage = 0
    for (const usage of this.containerUsageColl) {
      quantity += usage.quantity
      weight += usage.weight
      cubage += usage.cubage
    }
    this.view.usagesTotalDesc.usageTotalQuantity = String(quantity)
    this.view.usagesTotalDesc.usageTotalWeight = NumberUtils.formatNumber(weight, 3)
    this.view.usagesTotalDesc.usageTotalCubage = NumberUtils.formatNumber(cubage, 3)
  }

  refreshContainerUsageColl(container) {
    this.containerUsageColl = []
    for (const usage of container.containerUsage) {
      if (!StrUtils.isEmpty(usage.containerUuid) && !StrUtils.isEmpty(usage.jobUuid)) {
        this.containerUsageColl.push(usage)
      }
    }
  }

  /**
   * 应用各个表格的数据
   */
  refreshDatas() {
    if (!this.job || StrUtils.isEmpty(this.job.uuid)) { return }

    this.manager = new ContainerManager(this.job)
    this.manager.clearRemoveSourceUsages()
    this.refreshSalves()
    this.refreshContainers()
  }

  /**
   * 刷新小票
   */
  refreshSalves() {
    const manager = this.manager
    if (!manager) { return }
    this.view.lclSlaves = manager.getUnboxedSlaves()
    let quantity = 0
    var weight = 0
    let cubage = 0
    for (const slave of this.view.lclSlaves) {
      quantity += this.getItemLeft(slave)
      weight += this.getWeightLeft(slave)
      cubage += this.getCubageLeft(slave)
    }
    this.view.slaveTotalDesc.slaveTotalQuantity = String(quantity)
    this.view.slaveTotalDesc.slaveTotalWeight = NumberUtils.formatNumber(weight, 3)
    this.view.slaveTotalDesc.slaveTotalCubage = NumberUtils.formatNumber(cubage, 3)
  }

  // 加入小票
  addSlaveHandler() {
    if (!this.job) {
      return
    }
    this.view.querySELclDialog.visible = true
  }

  slaveAddedHandler(rows) {
    const jobKeys = Array.from(rows, p => p.uuid)

    // batchAddJob 后端实现 1.同步 jobKeys 的小票的 etd,vessel 等；2.重新合计主票中的件毛体以及计费重量; 3.进口刷新小票仓库信息
    batchAddJob(jobKeys, this.job.uuid, this.job.mbl, this.view.location).then(res => {
      if (res.data && res.data.length > 0) {
        for (const item of rows) {
          item.lclMasterUuid = this.job.uuid
          item.version = item.version + 1
          if (!this.job.lclSlaves) {
            this.job.lclSlaves = []
          }
          this.job.lclSlaves.push(item)
        }
        this.view.lclSlaves = this.job.lclSlaves
        this.refreshSlaveUsageColl()
        this.view.$emit('addSlavedJob', rows)
        this.refreshSalves()
      }
    })
  }

  // 移除小票
  removeSlaveHandler() {
    if (!this.view.selectedSlave.uuid) {
      this.$message.info(this.view.$t('请选择小票记录'))
      return
    }

    this.$confirm(this.view.$t('Message.AreYouSureYouWantToRemoveTheSubBill'), this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      this.removeSlaveCheckHandler()
    })
  }

  /**
   * 移除小票
   * @returns {Promise<void>}
   */
  async removeSlaveCheckHandler() {
    const slave = this.view.selectedSlave

    await new SeaImportJob(slave).getContainerUsages()

    if (slave.quantityContract !== this.getItemLeft(slave) || slave.weightContract !== this.getWeightLeft(slave) ||
      slave.cubageContract !== this.getCubageLeft(slave)) {
      this.$message.warning(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
      return
    }

    for (const c of slave.containerUsages) {
      if (c.container && c.container.jobUuid && c.container.jobUuid === this.job.uuid) {
        this.$message.warning(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
        return
      }
    }
    slave.lclMaster = null
    // 使用基本tab 的移除小票方法
    const jobKeys = [slave.uuid]
    await checkJobForShared(jobKeys).then(res => {
      if (res.data) {
        this.view.$message.warning(res.data + this.view.$t('CargoMsg.Cargo_SmallTicketCannotBeRemoved'))
      } else {
        const loading = getLoading4Cxt(this.view)
        batchRemoveJob(jobKeys, this.view.location).then(res => {
          this.slaveResultHandler(res.data, jobKeys)
        }).finally(() => {
          loading.close()
        })
      }
    })
  }

  slaveResultHandler(num, jobKeys) {
    if (num > 0) {
      // 更新主票上的 件重尺
      syncLclSlaveMasterJob({ jobUuid: this.job.uuid })

      this.job.lclSlaves = ''
      new SeaImportJob(this.job).getLclSlaves().then(data => {
        this.job.lclSlaves = data
        this.view.lclSlaves = this.job.lclSlaves
        this.refreshSlaveUsageColl()
      })
      this.view.$emit('removeJobFromMaster', jobKeys, 'tabLclContainer')
    }
    this.refreshSalves()
    this.$message.success(this.view.$t('Message.RemovedSuccesfully'))
  }

  getItemLeft(input) {
    let quantity = input.quantityContract
    for (const usage of input.containerUsages) {
      quantity = quantity - usage.quantity
    }
    return Number(quantity)
  }
  getWeightLeft(input) {
    let weight = input.weightContract
    if (isNaN(weight)) {
      weight = 0.0
    }
    for (const usage of input.containerUsages) {
      let usedWeight = usage.weight
      if (isNaN(usedWeight)) {
        usedWeight = 0.0
      }
      weight = weight - usedWeight
    }
    return Number(weight)
  }
  getCubageLeft(input) {
    let cubage = input.cubageContract
    if (isNaN(cubage)) {
      cubage = 0.0
    }
    for (const usage of input.containerUsages) {
      let usedCubage = usage.cubage
      if (isNaN(usedCubage)) {
        usedCubage = 0.0
      }
      cubage = cubage - usedCubage
    }
    return Number(cubage)
  }
  // 装箱
  addToContainerHandler() {
    const slaves = this.view.gridOptions.api.getSelectedRows()

    const containers = this.view.selectedContainer// this.view.left.gridApi.getSelectedRows()
    if (!containers || this.job.containers.length === 0) {
      this.$message.warning('请选中一个箱子')
      return
    }

    if (slaves.length > 0 && slaves[0]) { this.addToContainer(slaves, this.view.selectedContainer) }
  }

  addToContainer(slaves, container) {
    container.isDirty = true

    const usages = this.manager.multiLoadContainer(slaves, container)
    this.refreshSalves()
    this.refreshUsages()
    // 选中指定行
    this.view.$nextTick(() => {
      this.setUsageGridSelect(usages)
    })

    // 记录 装箱(装箱会改变 removedContainerUsages 中的值) 同cargo中的syncActionItems
    this.syncActionItems()
  }

  // 移除装箱
  removeToContainerHandler() {
    const usages = this.view.right.gridApi.getSelectedRows()
    if (usages.length > 0) {
      this.removeToContainer(usages)
    }
  }

  /**
   * 卸载
   */
  removeToContainer(usages) {
    const container = this.view.selectedContainer
    container.isDirty = true
    this.manager.multiUnloadContainer(usages)
    this.refreshSalves()
    this.refreshUsages()

    // 记录 装箱(移除装箱会改变 removedContainerUsages 中的值) 同cargo中的syncActionItems
    this.syncActionItems()
  }

  /**
   * 返回需要同步保存的对象列表
   */
  syncActionItems() {
    this.job.delContainerUsageUuids = []
    for (const item of this.manager.removedContainerUsages) {
      this.job.delContainerUsageUuids.push(item.entity.uuid)
    }
  }
  /**
   * 验证
   */
  validateForm() {
    if (this.manager) {
      const msg = this.manager.validateSlavesUsage()
      if (msg.length > 0) {
        throw new TabError(msg, 'tabLclContainer')
      }
    }
    return true
  }
}
